// extracted by mini-css-extract-plugin
export default {"homologacaoBotoes":"ArquivarConsulta_homologacaoBotoes__pkOhG","motivoArquivamento":"ArquivarConsulta_motivoArquivamento__8310x"};